 const wishlistKey = 'wishlist-items';

  function getWishlist() {
    return JSON.parse(localStorage.getItem(wishlistKey)) || [];
  }

  function saveWishlist(items) {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
  }

  function findItem(wishlist, handle) {
    return wishlist.find(item => item.handle === handle);
  }

  function openCartDrawer() {
    const event = new CustomEvent('cart:refresh', { bubbles: true });
    document.body.dispatchEvent(event);
  }

  function removeFromWishlistByHandle(handle) {
    const updated = getWishlist().filter(item => item.handle !== handle);
    saveWishlist(updated);
  }

  function toggleWishlist(handle, om, button) {
    let wishlist = getWishlist();
    const existingItem = findItem(wishlist, handle);

    if (existingItem) {
      wishlist = wishlist.filter(item => item.handle !== handle);
      button.classList.remove('in-wishlist');
      button.querySelector('.wishlist-label').textContent = 'Save for Later';
    } else {
      wishlist.push({ handle, om });
      button.classList.add('in-wishlist');
      button.querySelector('.wishlist-label').textContent = 'Saved';
    }

    saveWishlist(wishlist);
  }

  function initWishlistButtons() {
    const buttons = document.querySelectorAll('.wishlist-button:not(.wishlist-bound)');
    const wishlist = getWishlist();

    buttons.forEach(button => {
      const handle = button.dataset.productHandle;
      const om = parseInt(button.dataset.productOm || '1');

      // Skip if already initialized
      button.classList.add('wishlist-bound');

      const existingItem = findItem(wishlist, handle);
      if (existingItem) {
        button.classList.add('in-wishlist');
        const label = button.querySelector('.wishlist-label');
        if (label) label.textContent = 'Saved';
      }

      button.addEventListener('click', () => {
        toggleWishlist(handle, om, button);
      });
    });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', initWishlistButtons);

  // Re-init on Shopify filter re-render
  document.addEventListener('shopify:section:load', initWishlistButtons);

  // Fallback observer
  const observer = new MutationObserver(() => {
    initWishlistButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });


   function renderWishlist() {
    const wishlist = getWishlist();
    const wishlistContainer = document.getElementById('wishlist-container');
    if (!wishlistContainer) return;

    wishlistContainer.innerHTML = '';

    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = '<p class="wishlist-empty">Your list is empty.</p>';
      return;
    }

    const fetches = wishlist.map(item =>
      fetch(`/products/${item.handle}.js`)
        .then(res => res.ok ? res.json() : null)
        .then(product => {
          if (!product) return;

          const om = parseInt(item.om) || 1;
          const showOrderMin = om !== 1;

          const itemHTML = `
            <div class="wishlist-item" data-handle="${product.handle}" data-variant-id="${product.variants[0].id}" data-qty="${om}">
              <a href="/products/${product.handle}">
                <img src="${product.images[0]}" alt="${product.title}" style="width: 120px;">
              </a>
              <div>
                <h4>${product.title}</h4>
                ${showOrderMin ? `<p>Order Minimum: ${om}</p>` : ''}
                <div class="action-buttons">
                <a class="view-product" href="/products/${product.handle}" target="_blank">View</a>
                <button class="wishlist-button add-single-button wishlist-bound" data-id="${product.variants[0].id}" data-qty="${om}" onclick="addToCart(this.getAttribute('data-id'), this)" data-handle="${product.handle}">
                  Add to Cart
                </button>
                <button class="wishlist-button remove-button">Remove</button>
                </div>
              </div>
            </div>
          `;
          wishlistContainer.insertAdjacentHTML('beforeend', itemHTML);
        })
        .catch(() => {})
    );

    Promise.all(fetches).then(() => {
      // Remove button logic
      document.querySelectorAll('.remove-button').forEach(button => {
        button.addEventListener('click', function () {
          const item = this.closest('.wishlist-item');
          const handle = item.dataset.handle;
          removeFromWishlistByHandle(handle);
          renderWishlist();
        });
      });

      // Add to cart per item
      document.querySelectorAll('.add-single-button').forEach(button => {
        button.addEventListener('click', function () {
          const variantId = this.dataset.id;
          const qty = parseInt(this.dataset.qty) || 1;
          const handle = this.dataset.handle;
          addToCart(variantId, qty, handle);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderWishlist();
  });

document.addEventListener('DOMContentLoaded', function () {
  const addAllBtn = document.getElementById('add-all-to-cart');
  if (addAllBtn) {
    addAllBtn.addEventListener('click', async function () {
      const wishlist = getWishlist();

      if (wishlist.length === 0) {
        alert('Your wishlist is empty.');
        return;
      }

      // Disable button while processing
      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding...';

      for (const item of wishlist) {
        try {
          const res = await fetch(`/products/${item.handle}.js`);
          if (!res.ok) continue;
          const product = await res.json();
          const variantId = product.variants[0].id;
          const quantity = parseInt(item.om) || 1;

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity }]
            })
          });
        } catch (err) {
          console.error(`Failed to add ${item.handle} to cart`, err);
        }
      }

      // Trigger cart drawer
      openCartDrawer();
      alert('All items from your saved items have been added to your cart.');
      // Re-enable button
      addAllBtn.disabled = false;
      addAllBtn.textContent = 'Added to Cart';
    });
  }
});
